import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useAuth } from "$/lib/context/AuthContext";
import { useEffect } from "react";
import { ROUTES } from "$/lib/utils/constants/routes.constants";

export const Route = createFileRoute("/_auth_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) navigate({ to: ROUTES.HOMEPAGE });
  }, [navigate, user]);

  return <Outlet />;
}
